export default (type, colors) => {
  const styles = {
    type1: {
      'c-buttons__container': {
        textAlign: 'right',
        marginTop: 30,
        marginBottom: 30,
        position: 'relative'
      },
      'c-button__icon': {
        width: 33,
        height: 33,
        background: 'none',
        borderRadius: '50%',
        fontSize: 18,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0px 1px 9px rgba(0, 0, 0, 0.15)',
        color: colors.secondary,
        customCSS: `
          .c-button__icon svg path {
            fill: ${colors.secondary};
          }
        `
      },
      'c-button__svg': {
        width: 40,
        height: 40,
        customCSS: `
          .c-button__svg {
            background: none;
            text-align: center;
            color: #c4c4c4;
          }
          .c-button__svg.state-selected {
            border: none!important;
            color: ${colors.secondary};
          }
          .c-button__svg div {
            margin: auto;
          }
          .c-button__svg .button__text {
            margin-top: 10px;
            text-transform: none;
            font-size: 16px;
            color: inherit;
          }
          .c-button__svg.state-selected svg *[fill]:not(*[fill=""]) {
            fill: ${colors.secondary};
          }
          .c-button__svg.state-selected svg *[stroke]:not(*[stroke=""]) {
            stroke: ${colors.secondary};
          }
        `
      },
      'with-margin': {
        marginLeft: 10,
      },
      'without-paddings': {
        padding: 0,
      },
      'c-icon': {
        color: 'inherit',
      },
      'c-button__new': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: colors.primary,
        fontSize: 14,
        marginLeft: 'auto'
      },
      'c-button__new-hidden': {
        visibility: 'hidden',
        opasity: 0,
      },
      'c-icon__add': {
        color: colors.primary,
        width: 33,
        height: 33,
        fontSize: 14,
        marginRight: 14,
        lineHeight: 33
      },
      'c-buttons__row': {
        visibility: 'hidden',
        opasity: 0,
        display: 'flex',
        transform: 'translateY(-50%)',
        position: 'absolute',
        right: 0,
        top: '50%',
      },
      'c-buttons__row-open': {
        visibility: 'visible',
        opasity: 1
      },
      'c-button__col': {
        marginBottom: 10,
        marginLeft: 20,
        fontSize: 12
      },
      'cancel-btn': {
        color: '#c4c4c4',
        fontSize: 12
      },
      'save-btn': {
        background: colors.secondary,
        color: '#fff',
        fontSize: 14,
        textTransform: 'uppercase',
        width: 120,
        height: 38,
        borderRadius: 3,
        marginLeft: 30
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/cContentButtons.js